<!--title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div class="tw-flex-center flex-column">
      <!-- organizationCredit -->
      <list-group-item
        class="tw-w-full"
        [label]="'common.organizationCredit' | translate"
        [hasCurrency]="true"
        [isShowValue]="false"
      >
        <div
          class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
          content
          [credit]="organizationCredit"
        >
          <div class="credit-number">
            <span class="credit-number-text">
              {{ organizationCredit | numberSeparator | checkValue }}
            </span>
          </div>
        </div>
        <i
          icon
          class="mdi mdi-domain tw-text-gray-700 dark:tw-text-gray-300 tw-ml-2 tw-mb-2 mdi-20px"
        ></i>
      </list-group-item>

      <!-- userCredit -->
      <list-group-item
        class="tw-w-full"
        [label]="'common.currentUserCredit' | translate"
        [hasCurrency]="true"
        [isShowValue]="false"
      >
        <div
          class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
          content
          [credit]="userCredit"
        >
          <div class="credit-number">
            <span class="credit-number-text">
              {{ userCredit | numberSeparator | checkValue }}
            </span>
          </div>
        </div>
        <i
          icon
          class="mdi mdi-account-outline tw-text-gray-700 dark:tw-text-gray-300 tw-ml-2 tw-mb-2 mdi-20px"
        ></i>
      </list-group-item>

      <!-- typeTransaction -->
      <custom-select-search
        class="tw-w-full tw-mt-3"
        label="common.typeTransaction"
        [items]="
          $any([
            {
              value: TypeTransactions.Increase,
              name: 'common.increase' | translate
            },
            {
              value: TypeTransactions.Decrease,
              name: 'common.decrease' | translate
            }
          ])
        "
        [control]="form?.get('typeTransactions')"
        optionTitle="name"
        optionValue="value"
        [removable]="false"
        [(value)]="model.typeTransactions"
        (valueChange)="onChangeTypeTransactions()"
      >
      </custom-select-search
      ><!-- amount -->
      <form-field
        type="tel"
        [hasNumberSeparator]="true"
        [control]="form?.get('amount')"
        class="tw-w-full tw-px-0"
        [(value)]="model.amount"
        label="common.amount"
        [hasCurrency]="true"
      >
      </form-field>

      <!-- descriptions -->
      <form-textarea
        class="tw-w-full"
        label="common.description"
        [(value)]="model.description"
        [control]="form?.get('description')"
        [rows]="2"
        maxlength="100"
      >
      </form-textarea>

      <!-- form btns-->
      <app-form-btns
        class="tw-w-full tw-px-0"
        [customTitle]="
          model.typeTransactions == TypeTransactions.Increase
            ? 'common.increaseCredit'
            : 'common.decreaseCredit'
        "
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        [submitBgColor]="
          model.typeTransactions == TypeTransactions.Increase
            ? 'success'
            : 'danger'
        "
        closeBgColor="light-dark"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </div>
  </form>
</div>
